export default ['en-US', 'en-GB', 'en-CA', 'en-AU', 'de-DE', 'de-AT', 'pl-PL', 'es-ES']
